// كل إطار الآن له شكله الخاص (borderRadius) مخزّن معه في قاعدة البيانات
// (frames/{frameId}/borderRadius) وينسخ إلى kunaiu_bank/{uid}/frame_border_radius
// وقت الشراء أو التفعيل، بدل الاعتماد على subscribed فقط لتحديد دائري/مربع.

// القيمة الافتراضية عند عدم وجود frame_border_radius (توافقاً مع الإطارات القديمة)
export const DEFAULT_FRAME_BORDER_RADIUS = '10%';

// borderRadius الإطار الخارجي وصورة الفريم نفسها
export const getFrameBorderRadius = (data) => data?.frame_border_radius || DEFAULT_FRAME_BORDER_RADIUS;

// borderRadius صورة البروفايل الداخلية: يطابق شكل الإطار حتى تكون الصورة دائرية أو مربعة أو مخصصة.
export const getInnerImageBorderRadius = (frameBorderRadius) => {
  if (!frameBorderRadius) return DEFAULT_FRAME_BORDER_RADIUS;
  return frameBorderRadius;
};
